import { render, staticRenderFns } from "./UserRestoreContainer.vue?vue&type=template&id=bf9269f8"
import script from "./UserRestoreContainer.vue?vue&type=script&lang=js"
export * from "./UserRestoreContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports